// extracted by mini-css-extract-plugin
module.exports = {"root":"_6e96ddb7","grid":"_ab634522"};